module.exports = "{{ name }}\n"